<div class="container">
  <div class="container-header">
    <h2>Parece que você está utilizando uma versão antiga do Firefox</h2>
    <p>
      Para prosseguir será necessário autorizar o nosso certificado conforme imagem abaixo. 
    </p>
    <p>
      <a [href]="urlAutorizacao">clique aqui para autorizar</a>.
    </p>
  </div>
  <img src="assets/images/autorizar-certificado.gif" width="80%">
</div>